"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class ErrorText
 * @description a component for showing styled error messages,
 * typically used to format server-side errors.
 */
var React = require("react");
var Aria_1 = require("../resources/Aria");
var svgs_1 = require("../utils/svgs");
/**
 * OUI ErrorText component for showing styled error messages,
 * typically used to format server-side errors.
 *
 * @oui-component ErrorText
 */
var ErrorText = function (props) {
    var children = props.children, testId = props.testId, showAlert = props.showAlert;
    var icon = children && svgs_1.default("ErrorText");
    return (React.createElement("div", __assign({ className: "oui-form-danger oui-margin-small-bottom", "data-test-id": testId }, (showAlert === true ? { role: Aria_1.Roles.Alert } : {})),
        icon,
        children));
};
exports.default = ErrorText;
//# sourceMappingURL=ErrorText.js.map